import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-container',
  templateUrl: './form-container.component.html',
  styleUrls: ['./form-container.component.scss'],
  animations:  [
    trigger('collapseChange', [
      state('true', style({height: '0', padding: '0', 'min-height': '0'})),
      state('false', style({height: '*'})),
      transition(':enter', []),
      transition('* => *', animate('.20s ease-in'))
    ]),
    trigger('iconChange', [
      state('true', style({transform: 'rotate( 180deg )'})),
      state('false', style({transform: 'rotate( 0deg )'})),
      transition(':enter', []),
      transition('* => *', animate('.20s'))
    ])
  ]
})
export class FormContainerComponent {
  @Input() collapsible                        = false;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('open') _open                        = true;
  @Input() loading                            = false;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  displayContent = true;

  get open() {
    return this._open;
  }

  set open(status: boolean) {
    this._open = status;
    this.openChange.emit(status);
    this.updateDisplay();
  }

  toggle() {
    this.open = !this.open;
  }

  updateDisplay() {
    if (this.open) {
      this.displayContent = true;
    } else {
      setTimeout(() => {
        if (!this.open) {
          this.displayContent = false;
        }
      }, 250);
    }
  }
}
